var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMissionImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 445,
    height: 410,
    viewBox: "0 0 445 410",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.505 386.848C115.505 388.475 95.4153 389.785 70.6303 389.785C45.8454 389.785 25.7556 388.475 25.7556 386.848C25.7556 385.222 45.8454 383.912 70.6303 383.912C95.4153 383.912 115.505 385.222 115.505 386.848Z",
    fill: "#6497FB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M377.792 322.695C451.566 248.875 451.566 129.188 377.792 55.3675C304.018 -18.453 184.407 -18.453 110.633 55.3675C36.8595 129.188 36.8595 248.875 110.633 322.695C184.407 396.516 304.018 396.516 377.792 322.695Z",
    fill: "#3A7AFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9444 385.922H83.3388C85.8444 385.922 88.0114 384.115 88.4403 381.631L94.9864 343.526H46.2969L52.843 381.631C53.2719 384.093 55.4163 385.922 57.9444 385.922Z",
    fill: "#5089FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0695 156.347C33.0241 145.98 39.367 132.767 42.753 118.808C50.3826 87.4118 68.2376 65.3669 89.0723 65.3669C116.837 65.3669 139.319 104.488 139.319 152.779C139.319 201.047 85.0995 299.707 74.5355 300.317C65.2129 300.859 9.75154 219.433 9.75154 193.819C9.72896 178.415 14.9884 164.772 23.0695 156.347Z",
    fill: "#6497FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4361 125.742C70.5626 134.822 69.1857 144.015 68.1473 153.208C67.0864 162.423 66.4543 171.662 66.1609 180.922C65.5063 199.421 66.1609 217.965 67.8313 236.373C69.4791 254.804 72.1201 273.123 75.5286 291.283C77.1538 300.363 79.1854 309.442 81.0589 318.522L86.7699 345.762L80.1109 347.05L75.2352 319.629C73.6325 310.481 71.8944 301.401 70.5174 292.141C67.6507 273.732 65.5514 255.211 64.4454 236.622C63.3167 218.033 63.2264 199.398 64.4454 180.832C65.0323 171.549 65.9577 162.288 67.2895 153.095C68.6213 143.925 70.2917 134.777 72.4361 125.742Z",
    fill: "#3A7AFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24594 260.88C-2.73124 233.618 -2.3475 208.411 8.05856 204.593C17.3134 201.205 31.3988 215.842 41.4211 238.293C43.1818 242.223 46.2517 245.521 50.202 247.238C57.9444 250.603 63.9939 261.106 64.7163 273.845C65.6192 289.769 52.2109 309.126 52.2109 309.126C52.2109 309.126 17.0877 287.827 7.24594 260.88Z",
    fill: "#5089FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5752 219.411C25.3266 238.632 34.4235 258.238 42.4142 278.295C46.3871 288.324 50.1116 298.488 53.362 308.833C56.5899 319.178 59.3664 329.68 61.1497 340.432L57.4477 340.974C56.0031 330.403 53.5652 319.945 50.6533 309.601C47.7188 299.278 44.3329 289.046 40.6536 278.95C33.2723 258.735 24.7849 238.903 15.5752 219.411Z",
    fill: "#3A7AFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1038 243.737C88.0339 251.326 85.3252 259.073 82.8422 266.866C80.3818 274.681 78.1245 282.541 76.2735 290.492C74.4677 298.443 72.8876 306.461 71.9621 314.525C71.0818 322.588 70.7206 330.697 71.3752 338.647L66.8832 338.986C66.5446 330.561 67.3347 322.249 68.5988 314.073C69.908 305.896 71.8944 297.878 74.084 289.95C76.2961 282.022 78.9371 274.229 81.7587 266.527C84.6029 258.802 87.6728 251.191 91.1038 243.737Z",
    fill: "#3A57FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7482 350.212H94.4897C96.1827 350.212 97.5822 348.834 97.5822 347.118V339.754C97.5822 338.06 96.2052 336.66 94.4897 336.66H46.7482C45.0553 336.66 43.6558 338.038 43.6558 339.754V347.118C43.6783 348.812 45.0553 350.212 46.7482 350.212Z",
    fill: "#3A6BFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.927 299.436H327.892V173.762H416.852L395.927 299.436Z",
    fill: "#50374B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.263 404.444C403.263 407.515 365.16 410.023 318.186 410.023C271.189 410.023 233.109 407.538 233.109 404.444C233.109 401.372 271.212 398.865 318.186 398.865C365.183 398.865 403.263 401.349 403.263 404.444Z",
    fill: "#C8E6EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.661 386.758L140.109 241.659L133.044 239.829L95.1218 386.758H102.661Z",
    fill: "#3A7AFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.034 386.758L309.112 239.829L302.046 241.659L339.517 386.758H347.034Z",
    fill: "#A5C8CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.781 249.112H95.7537C93.3159 249.112 91.3521 247.147 91.3521 244.708V232.15C91.3521 229.71 93.3159 227.745 95.7537 227.745H350.781C353.219 227.745 355.183 229.71 355.183 232.15V244.708C355.183 247.125 353.219 249.112 350.781 249.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.156 303.005H341.368V390.756H349.156V303.005Z",
    fill: "#A5A0AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.089 310.798H290.579C286.268 310.798 282.792 307.297 282.792 303.005C282.792 298.691 286.291 295.213 290.579 295.213H382.089C384.572 295.213 386.717 293.519 387.281 291.102L412.472 182.729C413.443 178.528 417.642 175.93 421.818 176.902C426.016 177.873 428.612 182.074 427.641 186.253L402.45 294.625C400.238 304.157 391.864 310.798 382.089 310.798Z",
    fill: "#695A6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.399 401.778H375.611C375.611 397.848 372.406 394.641 368.478 394.641H322.701C318.773 394.641 315.568 397.848 315.568 401.778H307.78C307.78 393.557 314.462 386.848 322.701 386.848H368.478C376.717 386.848 383.399 393.534 383.399 401.778Z",
    fill: "#695A6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.873 220.811H129.59L114.218 177.241C113.406 174.959 115.099 172.565 117.537 172.565H178.348C179.837 172.565 181.169 173.514 181.666 174.914L197.873 220.811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.496 185.417L175.255 181.939H125.73L126.949 185.417H176.496Z",
    fill: "#FF8291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.618 191.47L177.016 186.863H127.469L129.094 191.47H178.618Z",
    fill: "#41B4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.747 194.61L179.138 192.939H129.613L130.2 194.61H179.747Z",
    fill: "#FAF58C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.719 196.078L136.159 211.505H156.181L150.741 196.078H130.719Z",
    fill: "#FF8C46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.231 196.078L157.671 211.505H185.142L179.702 196.078H152.231Z",
    fill: "#41B4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.761 176.924L191.688 216.429H132.705L118.778 176.924H177.761ZM178.37 172.565H117.536C115.121 172.565 113.428 174.959 114.218 177.241L129.59 220.811H197.85L181.666 174.891C181.192 173.491 179.86 172.565 178.37 172.565Z",
    fill: "#50374B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.362 227.677H139.026C134.737 227.677 130.922 224.583 129.613 219.998H212.478C216.293 219.998 219.362 223.454 219.362 227.677Z",
    fill: "#695A6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.776 223.228L222.545 222.234C226.924 221.082 231.416 220.495 235.953 220.495H246.472V227.587L219.362 227.677C216.699 227.7 216.202 223.905 218.776 223.228Z",
    fill: "#FFAF82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.438 157.183C356.673 182.413 304.371 227.723 297.396 227.7L241.912 227.564C240.942 223.905 240.784 221.76 241.777 218.281L290.557 206.174L316.583 164.818L344.438 157.183Z",
    fill: "#6497FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.014 393.308L265.163 403.043C264.869 403.969 264.282 404.782 263.492 405.325C260.625 407.335 252.68 408.08 251.077 405.912C249.384 403.63 256.314 401.214 259.835 399.203L260.671 394.934L267.014 393.308Z",
    fill: "#9B2D3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.672 251.958L376.559 250.761L255.75 261.626C245.028 262.597 237.398 272.445 239.114 283.061L258.91 399C261.415 399.971 264.102 399.881 266.923 399L271.122 295.935L332.994 298.33C358.614 299.324 379.178 277.459 376.672 251.958Z",
    fill: "#DCBE82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.132 272.016L326.809 262.642L376.537 250.761L255.727 261.626C245.005 262.597 237.375 272.445 239.091 283.061L243.335 309.217L269.203 344.836L271.099 295.935L300.466 297.065C293.604 288.933 296.403 276.443 306.132 272.016Z",
    fill: "#C8A06E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.177 354.368L319.608 358.818C320.285 359.699 320.601 360.805 320.466 361.912C320.037 365.503 314.62 372.844 311.956 372.731C308.864 372.618 313.017 361.28 313.017 361.28L311.888 357.146L316.177 354.368Z",
    fill: "#9B2D3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.464 220.585C282.566 226.187 248.978 239.174 228.708 251.168C219.498 256.634 218.008 269.396 225.728 276.804L311.279 359.179L317.735 354.391L270.332 271.767L312.498 256.95C310.827 244.369 307.825 230.681 307.464 220.585Z",
    fill: "#DCBE82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.482 255.866C311.482 255.866 301.076 196.417 308.999 176.834C326.764 132.789 367.011 139.701 367.011 139.701C367.011 139.701 395.227 150.023 393.579 210.873L385.566 257.899L375.431 254.85C375.431 254.827 335.522 269.418 311.482 255.866Z",
    fill: "#3A6BFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.887 127.73L339.043 145.573C338.772 147.313 339.901 148.984 341.617 149.323C346.537 150.272 356.786 150.656 367.598 141.44L358.343 113.5L341.887 127.73Z",
    fill: "#FF9669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.352 139.452C370.352 139.452 338.569 168.522 364.099 280.825L384.866 275.494L400.599 177.173C400.599 177.173 396.514 159.623 370.352 139.452Z",
    fill: "#6497FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.798 225.645C394.798 225.645 379.968 226.932 378.388 228.061C377.417 228.739 375.521 230.749 374.212 232.195C373.647 232.805 374.099 233.776 374.911 233.776L399.787 233.686L394.798 225.645Z",
    fill: "#FFAF82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.581 202.29L400.599 177.173C400.599 177.173 396.762 160.684 372.722 141.327C377.733 162.717 387.078 182.548 396.581 202.29Z",
    fill: "#5089FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.352 139.452C396.288 150.068 419.854 163.191 439.583 180.403C446.58 186.704 446.422 192.329 441.208 196.982L399.787 233.934L391.503 224.944L413.511 196.304C414.436 195.084 414.053 193.322 412.676 192.622L372.654 172.52L370.352 139.452Z",
    fill: "#6497FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.258 106.837C334.258 106.837 334.89 133.489 343.174 136.426C347.576 137.984 350.51 137.126 353.219 135.003C357.734 131.479 360.42 123.89 362.293 115.601C365.318 102.319 359.314 98.5473 355.431 98.5473C351.549 98.5473 335.183 93.3748 334.258 106.837Z",
    fill: "#FFAF82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.317 82.8267C322.317 82.8267 313.198 105.911 328.818 111.309C328.818 111.309 332.836 114.065 346.086 103.562C359.359 93.0586 357.689 116.007 357.689 116.007L359.246 115.013L362.158 109.457C362.158 109.457 363.648 106.769 364.618 109.931C365.589 113.116 360.262 118.83 360.262 118.83L361.12 122.377L362 125.019C362 125.019 364.506 114.787 367.259 111.196C370.013 107.605 375.837 102.907 373.625 96.537C371.413 90.1675 362.564 91.8389 356.492 94.5945C350.42 97.3501 339.089 87.1182 335.906 82.8493C332.678 78.5351 325.342 75.4859 322.317 82.8267Z",
    fill: "#50374B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.962 110.609C340.037 111.241 339.201 111.58 338.344 111.896C337.463 112.19 336.628 112.483 335.5 112.574C335.974 111.535 336.876 110.88 337.847 110.518C338.818 110.202 339.946 110.089 340.962 110.609Z",
    fill: "#5A2D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.258 114.065L341.549 122.218C341.346 123.89 343.264 124.184 344.1 124.184C344.912 124.184 345.522 123.483 345.409 122.67L344.258 114.065Z",
    fill: "#FF640A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.705 110.609C349.788 110.134 350.917 110.202 351.955 110.496C352.971 110.835 354.054 111.467 354.461 112.619C353.309 112.371 352.474 112.167 351.526 111.874C350.601 111.603 349.675 111.286 348.705 110.609Z",
    fill: "#5A2D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.646 116.459C340.646 117.498 340.24 118.356 339.72 118.356C339.201 118.356 338.795 117.52 338.795 116.459C338.795 115.42 339.201 114.561 339.72 114.561C340.24 114.584 340.646 115.42 340.646 116.459Z",
    fill: "#5A2D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.398 116.459C350.398 117.498 349.991 118.356 349.472 118.356C348.953 118.356 348.547 117.52 348.547 116.459C348.547 115.42 348.953 114.561 349.472 114.561C349.991 114.584 350.398 115.42 350.398 116.459Z",
    fill: "#5A2D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.646 126.239C340.646 128.475 342.452 130.282 344.687 130.282C346.921 130.282 348.727 128.475 348.727 126.239H340.646Z",
    fill: "#F9F8F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.386 117.159C355.386 119.847 353.196 122.038 350.51 122.038C347.824 122.038 345.635 119.847 345.635 117.159C345.635 114.471 347.824 112.28 350.51 112.28C353.196 112.28 355.386 114.471 355.386 117.159Z",
    stroke: "#965028",
    strokeWidth: 0.3231,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.678 116.459C342.678 119.147 340.488 121.338 337.802 121.338C335.116 121.338 332.926 119.147 332.926 116.459C332.926 113.771 335.116 111.58 337.802 111.58C340.488 111.58 342.678 113.771 342.678 116.459Z",
    stroke: "#965028",
    strokeWidth: 0.3231,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.091 116.865C343.129 115.826 344.822 115.826 345.861 116.865",
    stroke: "#965028",
    strokeWidth: 0.3231,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.251 116.075L360.646 110.383C361.571 109.412 363.106 109.457 363.986 110.451L364.957 111.58",
    stroke: "#965028",
    strokeWidth: 0.3231,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.19 114.561C362.451 117.046 362.045 119.147 360.623 118.717C359.201 118.266 358.795 115.578 359.698 112.687C360.601 109.796 362.497 107.831 363.919 108.282C365.318 108.711 366.605 111.106 364.19 114.561Z",
    fill: "#FFAF82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.324 302.599L327.012 257.425C328.412 246.357 337.802 238.067 348.953 238.067H407.8",
    stroke: "#50374B",
    strokeWidth: 3.8775,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.115 181.984H354.054V200.099H375.115V181.984Z",
    fill: "#3A6BFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.535 180.312H347.847V198.427H373.535V180.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.677 175.592H356.966V183.497H362.677V175.592Z",
    fill: "#FFDC8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.057 189.415C357.057 191.29 355.544 192.803 353.671 192.803C351.797 192.803 350.285 191.29 350.285 189.415C350.285 187.54 351.797 186.027 353.671 186.027C355.522 186.027 357.057 187.54 357.057 189.415Z",
    fill: "#B9CDD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.652 186.682H359.63V188.466H369.652V186.682Z",
    fill: "#B9CDD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.652 189.754H359.63V191.538H369.652V189.754Z",
    fill: "#B9CDD2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 445,
    height: 410,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionImg);
export default __webpack_public_path__ + "static/media/mission-img.31816ed0ca77bce64d07e938468fcee3.svg";
export { ForwardRef as ReactComponent };